module.exports = __webpack_public_path__ + "assets/books.3a8b6f5f.svg";